module.exports = __webpack_public_path__ + "static/media/10_2.2bad5c3e.jpg";